import { network } from './network';

export async function queryWorkOrderList(opts) {
	const res = await network({
		url: '/ai/api/v1/work_order/list',
		method: 'get',
		params: {
			page: opts.page
		},
		headers: {
			token: opts.token
		}
	});

	if (res.statusCode !== 200) {
		return Promise.reject(res);
	}

	return res;
}
